/**
 * @file Allow using app feature flags
 */
import { hasWwDebugUrlParam } from '@@/bits/dev_url_params'
import environment from '@@/bits/environment'
import window from '@@/bits/global'

type CurrentFlags =
  | 'accessControlSettingsV2'
  | 'accessControlSettingsV2RetroactiveUpdate'
  | 'activityPanelV2'
  | 'addPostLink'
  | 'affiliateSignupLink'
  | 'aiGrading'
  | 'aiImageSearch'
  | 'aiPermissionsForAiRecipes'
  | 'aiPermissionsForImageAndSpeechGeneration'
  | 'aiSuggestionsOnMakePage'
  | 'allSlideAsImageWithBanksy'
  | 'arLensesPreview'
  | 'attachmentPreviewWidthAdjustmentForGridFormat'
  | 'autoContentModeration'
  | 'banksy'
  | 'banksyDev'
  | 'billingAddress'
  | 'bulkEmailChangeForLibraries'
  | 'brahmsCheck'
  | 'campus'
  | 'changeEmailVerification'
  | 'classesV1'
  | 'classInformation'
  | 'classlinkSso'
  | 'classroomLicensesV2'
  | 'classroomPlanPricingExperiment'
  | 'cleverSso'
  | 'collaboratorSearchHideStrangers'
  | 'commandBar'
  | 'contentPickerCombinedAvRecorders'
  | 'commentAutoPublishOnUpload'
  | 'currentSlideAsImageWithBanksy'
  | 'customPostUserProperty'
  | 'customPostVoteAndRatingProperties'
  | 'dashboardAnnouncement'
  | 'dashboardFolderDalfe'
  | 'dashboardUpgradeCta'
  | 'dashHeaderCtaButton'
  | 'debugFrontend'
  | 'defaultDashboardLibraryNavigation'
  | 'delayedReactionSorting'
  | 'demoPadletPanel'
  | 'demoPadletSignup'
  | 'deprecateArsPlans'
  | 'deprecateDrivePage'
  | 'deprecateGoldPlans'
  | 'deviceUploads'
  | 'downloadWallAttachmentsV2'
  | 'editThumbnail'
  | 'editThumbnailForAudioVideoFiles'
  | 'embeddedPadletsOnExpandedPost'
  | 'exitTicket'
  | 'fasterDashSettings'
  | 'featuredSection'
  | 'fetchLinksWithWishes'
  | 'frontChat'
  | 'fullClientSurface'
  | 'galleryTemplates'
  | 'googleAppLicensing'
  | 'googleClassroom'
  | 'googleClassroomGrading'
  | 'googleWorkspaceRostering'
  | 'grading'
  | 'groupPostsV2'
  | 'hideCommentAttribution'
  | 'higherMonthlyPricingPlans'
  | 'internalNavigateImmediately'
  | 'joypixels8p0'
  | 'libraryGoogleAppLicensing'
  | 'librarySamlLogin'
  | 'librarySettingsConnectionsTab'
  | 'lmsUserGroupSync'
  | 'lottieWebWorker'
  | 'ltiDeepLinkingMenuV2'
  | 'ltiDefaultGradebookSetting'
  | 'magicPadlet'
  | 'makePageSimplifiedLayoutExperiment'
  | 'microsoftOneDrivePicker'
  | 'microsoftTeams'
  | 'mobileDeviceDprOverride'
  | 'notifyFailedPayments'
  | 'onboardingDemoV2'
  | 'onboardingDemoV2Copy'
  | 'onboardingGridLayout'
  | 'onboardingPanel'
  | 'openInAppBanner'
  | 'padletAnalytics'
  | 'padletContentInsightsAi'
  | 'pdndSurfaceGrid'
  | 'pdndSurfaceMap'
  | 'pdndSurfaceMatrix'
  | 'personalPricingPlansExperiment'
  | 'personalPricingPlansExperimentV2'
  | 'piInputV2'
  | 'piSandboxChat'
  | 'piSubmissionFormWidget'
  | 'platinumResellerSelfServe'
  | 'playVideoInExpanded'
  | 'postComposerAttachmentPickerV2'
  | 'posthog'
  | 'pptxImport'
  | 'prefetchSurface'
  | 'publicApi'
  | 'pwaInstallButton'
  | 'reactionsToCustomPropertiesMigration'
  | 'realtimeFetching'
  | 'remakeLink'
  | 'remakeSettingV2'
  | 'removeArchive'
  | 'removePlayMode'
  | 'rostering'
  | 'routeToEurope'
  | 'samlIdp'
  | 'samlSetup'
  | 'sandboxAi'
  | 'sandboxCode'
  | 'sandboxCopyPasteFrames'
  | 'sandboxLocaleFontOverride'
  | 'whiteboardPermissionsV2'
  | 'sandboxPngFramePreview'
  | 'sandboxRetainActiveTool'
  | 'sandboxSoundFx'
  | 'sandboxTextFormatting'
  | 'sandboxThemeBackgrounds'
  | 'sandboxVisualFx'
  | 'schoolLibraryFreeze'
  | 'schoolLibraryPermissions'
  | 'schoolLibrarySSO'
  | 'scrollSmoothnessTracking'
  | 'selfServeFreeTrial'
  | 'shareShortcuts'
  | 'showAnonymousUserNames'
  | 'showCommandPalette'
  | 'showInvitedLibraryUsers'
  | 'signUpSurface'
  | 'slideshowRemote'
  | 'slideshowSpotlight'
  | 'smartSuggestionsExperiment'
  | 'stripeBillingTax'
  | 'suggestedTemplates'
  | 'surfaceAiChat'
  | 'surfaceAiChatSchools'
  | 'surfaceAiChatSchoolsPermission'
  | 'surfaceCommentsPerPost'
  | 'surfaceCommentVideoPlayer'
  | 'surfaceConnectionsChange'
  | 'surfacePostVideoPlayer'
  | 'surfaceLibraryOrgVisitorPermissions'
  | 'surfaceLocaleFontOverride'
  | 'surfaceMapsV2'
  | 'surfaceRoleBadges'
  | 'taxIdOnCheckout'
  | 'threeDAttachment'
  | 'templatesWithNewSidebar'
  | 'transferPadletTool'
  | 'transferPostWithCustomProperties'
  | 'transferSchoolPadletPermission'
  | 'translatePadlet'
  | 'translatePadletV2'
  | 'translationReporter'
  | 'turnstileOnSignup'
  | 'undoRedoDeleteSectionActions'
  | 'unicodeFontLoading'
  | 'unifiedSandboxColors'
  | 'unlimitedSandboxesV2'
  | 'upgradeModalCopyAExperiment'
  | 'upgradeModalSingleStepExperiment'
  | 'userBeltY2025'
  | 'userBeltY2026'
  | 'virtualFieldTrip'
  | 'virtualFieldTripNarration'
  | 'virtualizedDashboard'
  | 'virtualizedPostsGrid'
  | 'wallCardMaxWidth'
  | 'wallContentProtection'
  | 'wallEngagementTime'
  | 'wallEngagementTimeTracking'
  | 'whiteboardPreloadApis'
  | 'yodishLanguage'
  | 'zapierIntegration'
  | 'nativeAccountSwitcher'
  | 'captionsTranslation'

function isAppUsing(feature: CurrentFlags, version?: null | number): boolean {
  const ww = window.ww || {}
  const viteAppFlip =
    window.wwStartingState != null && typeof window.wwStartingState === 'function' ? window.wwStartingState().flip : {}
  const flip = ww.flip || ww.vueStartingState?.flip || viteAppFlip || {}
  if (version) {
    return flip[feature] >= version
  }
  return flip[feature] || false
}

const isDebugMode =
  (environment === 'test' && ['true', 'yes', '1'].includes(process.env.WW_DEBUG ?? '')) ||
  isAppUsing('debugFrontend') ||
  hasWwDebugUrlParam()

if (environment !== 'production' && isAppUsing('debugFrontend')) {
  console.log('Already debugging frontend in dev.') // goodcheck-disable-line
}

// If on padlet.dev, use the local Banksy server to test PDF exports.
// Banksy and Banksy Dev on Cloud Run won't work because they cannot access a padlet.dev padlet.
// You will need to run the Banksy server first before you can test PDF exports.
// See: /services/banksy/README.md
const isAppUsingBanksyLocalDev = environment === 'development'

export { isAppUsing, isAppUsingBanksyLocalDev, isDebugMode }
